import React from "react";
import PlayerComponent from "./PlayerComponent";
import { Typography, Box } from "@mui/material";

function MediaRenderer({ contentProviderType, clickedContent, helper }) {
  const contentSize = {
    border: "2px solid #000000",
    height: "100%",
    width: "100%",
    maxHeight: "322px",
    position: "relative",
    borderRadius: "5px",
  };

  const fileType = clickedContent?.fileInfo?.fileType;

  // 🔥 EMPTY STATE (NO DATA)
  if (!clickedContent || !clickedContent?.fileInfo) {
    return (
      <Box
        sx={{
          height: "322px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          background: "#fafafa",
          border: "2px dashed #ddd",
          borderRadius: "10px",
        }}
      >
        <Typography variant="h6" sx={{ color: "#999", fontWeight: 600 }}>
          No Content Available
        </Typography>
        <Typography variant="body2" sx={{ color: "#bbb" }}>
          Please select or add content
        </Typography>
      </Box>
    );
  }

  // ✅ IMAGE
  if (["image", "png", "jpg", "jpeg", "PNG", "JPG"].includes(fileType)) {
    return (
      <div className="pdf-canvas-container">
        <img
          src={helper(clickedContent?.fileInfo?.fileURL)}
          alt={clickedContent?.fileInfo?.fileName}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: "8px",
          }}
        />
      </div>
    );
  }

  // ✅ VIDEO (S3 / VdoCipher etc)
  if (
    ["VdoCipher", "S3", "Google Cloud", "Diksha"].includes(contentProviderType)
  ) {
    return (
      <div style={contentSize}>
        <PlayerComponent
          key={clickedContent?.fileInfo?.id}
          videoId={
            clickedContent?.fileInfo?.videoID
              ? helper(clickedContent?.fileInfo?.videoID)
              : null
          }
          clickedContent={clickedContent}
          contentProviderType={contentProviderType}
        />
      </div>
    );
  }

  // ✅ YOUTUBE / WEBLINK
  if (["Youtube", "Weblink"].includes(contentProviderType)) {
    return (
      <div style={contentSize}>
        <PlayerComponent
          key={clickedContent?.fileInfo?.id}
          clickedContent={clickedContent}
          contentProviderType={contentProviderType}
        />
      </div>
    );
  }

  // 🔥 FALLBACK (UNSUPPORTED)
  return (
    <Box
      sx={{
        height: "322px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        background: "#fff3f0",
        border: "2px dashed #ff9800",
        borderRadius: "10px",
      }}
    >
      <Typography variant="h6" sx={{ color: "#e65100", fontWeight: 600 }}>
        Unsupported Media Type
      </Typography>
      <Typography variant="body2" sx={{ color: "#999" }}>
        This file format is not supported
      </Typography>
    </Box>
  );
}

export default MediaRenderer;
